import { BrowserRouter as Router, Routes, Route, Link, useLocation } from "react-router-dom";
import OnePieceResults from "./OnePieceResults";
import PokemonResults from "./PokemonResults";
import Home from "./Home";

function AppRouter() {
  return (
    <Router>
      <ContentWrapper />
    </Router>
  );
}

function ContentWrapper() {
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/onepiece" element={<OnePieceResults />} />
        <Route path="/pokemon" element={<PokemonResults />} />
      </Routes>

      {!isHome && (
        <div className="nav-buttons">
          <Link to="/onepiece" className="nav-button">One Piece TCG</Link>
          <Link to="/pokemon" className="nav-button">Pokémon TCG</Link>
          <Link to="/" className="nav-button">Anasayfa</Link>
        </div>
      )}
    </>
  );
}

export default AppRouter;
